// Which of a quote's tabs this browser hides (the library record page's tab
// chooser), as the CPQ prototype remembered it: per browser, in localStorage.
// Details can be hidden too; the record page keeps at least one tab showing.

const STORAGE_KEY = 'ops.quote.hiddenTabs';

/** The hidden tab keys, limited to `known`; nothing when storage is missing, refused or garbled. */
export function loadHiddenTabs(storage: Pick<Storage, 'getItem'> | undefined, known: readonly string[]): string[] {
  try {
    const parsed: unknown = JSON.parse(storage?.getItem(STORAGE_KEY) ?? '[]');
    if (!Array.isArray(parsed)) return [];
    return known.filter((key) => parsed.includes(key));
  } catch {
    return [];
  }
}

/** Stores the hidden tabs; a browser that refuses storage just doesn't remember them. */
export function saveHiddenTabs(storage: Pick<Storage, 'setItem'> | undefined, hidden: readonly string[]): void {
  try {
    storage?.setItem(STORAGE_KEY, JSON.stringify(hidden));
  } catch {
    // Private windows and full or blocked storage: nothing to remember.
  }
}
